export default "assets/images/img-817d13f4.png";